/*
 * @Author: 程序员
 * @Description: 存放全部路由
 * @Date: 2021-07-07 11:34:01
 */

/*页面开发中*/
// import Developing from "../views/Developing.vue";
/* 登录 */
import Login from "../views/login/Index.vue";
/* 错误页 */
import NotFound from "../views/NotFound.vue";
/* 服务未授权 */
import NotLicense from "../views/NotLicense.vue";
/* 管理员登录 */
import LoginAdmin from "../views/LoginAdmin.vue";
// 多平台选择页面
import PlatformSelection from "../views/PlatformSelection.vue";
// bi服务路由
import biRouter from "../views/bi/router";
// 轻应用中心路由
import lightAppsRouter from "../views/lightApps/router";
// 一张表
import oneTablePlatform from "../views/oneTablePlatform/router";
// 表单引擎路由
import workflowRouter from "../views/workflow/router";
// 任务管理
import taskManagement from "../views/taskManagement/router";
// 数据采集
import dataAcquisition from "../views/dataAcquisition/router";
// 小程序管理
import mobileLayout from "../views/mobileLayout/router";
//大屏
import leadingDriver from "../views/leadingDriver/router";

// 引入的路由
const routerList = [
  biRouter,
  lightAppsRouter,
  workflowRouter,
  oneTablePlatform,
  taskManagement,
  dataAcquisition,
  mobileLayout,
  leadingDriver,
];

// 对引入的路由数据处理
const web_routers = [],
  cms_routers = [];
routeClassification(routerList);

const __DEFAULT__ROUTES = [
  {
    path: "/",
    name: "root",
    redirect: { name: "login" },
    meta: {
      title: "首页",
      icon: "icon-zhuye",
    },
  },
  {
    path: "/login",
    name: "login",
    component: Login,
    meta: {
      title: "登录页",
      icon: "icon-zhuye",
    },
  },
  {
    path: "/loginAdmin",
    name: "loginAdmin",
    component: LoginAdmin,
    meta: {
      title: "登录页",
      icon: "icon-zhuye",
    },
  },
  {
    path: "/notFound",
    name: "notFound",
    component: NotFound,
    meta: {
      title: "错误页",
    },
  },
  {
    path: "/notLicense",
    name: "notLicense",
    component: NotLicense,
    meta: {
      title: "当前服务未激活 ",
    },
  },
  {
    path: "/platformSelection",
    name: "platformSelection",
    component: PlatformSelection,
    meta: {
      title: "多平台",
    },
  },
  {
    path: "*",
    name: "noPage",
    redirect: { name: "notFound" },
    meta: {
      title: "错误页",
    },
  },
];

const __AUTH__ROUTES = [
  {
    path: "/web",
    name: "web",
    component: () =>
      import(
        /* webpackChunkName: "[request]" */ "@layouts/forestage/ForestageLayout"
      ),
    redirect: { name: "webHomeIndex" },
    meta: {
      title: "用户前台",
      icon: "icon-zhuye",
    },
    children: [
      // {
      //   path: "home",
      //   name: "webHome",
      //   component: { render: (e) => e("router-view") },
      //   redirect: { name: "webHomeIndex" },
      //   meta: {
      //     title: "首页",
      //     icon: "icon-zhuye",
      //     platformName: "一网通办平台",
      //   },
      //   children: [
      //     {
      //       path: "index",
      //       name: "webHomeIndex",
      //       component: () =>
      //         import(
      //           /* webpackChunkName: "[request]" */ "@forestage/home/Home.vue"
      //         ),
      //       meta: {
      //         title: "用户前台首页",
      //         icon: "icon-zhuye",
      //         showFoot: false,
      //       },
      //     },
      //     {
      //       path: "notice",
      //       name: "webHomeNotice",
      //       component: { render: (e) => e("router-view") },
      //       redirect: { name: "noticeIndex" },
      //       meta: {
      //         title: "通知公告",
      //         icon: "icon-zhuye",
      //         showFoot: false,
      //       },
      //       children: [
      //         {
      //           path: "index",
      //           name: "noticeIndex",
      //           component: () =>
      //             import(
      //               /* webpackChunkName: "[request]" */ "@forestage/home/NoticeNewsIndex"
      //             ),
      //           meta: {
      //             title: "通知公告列表",
      //             icon: "icon-zhuye",
      //             showFoot: false,
      //           },
      //         },
      //         {
      //           path: "detail",
      //           name: "noticeDetail",
      //           component: () =>
      //             import(
      //               /* webpackChunkName: "[request]" */ "@forestage/home/NoticeNewsDetail"
      //             ),
      //           meta: {
      //             title: "通知公告详情",
      //             icon: "icon-zhuye",
      //             showFoot: false,
      //           },
      //         },
      //       ],
      //     },
      //     {
      //       path: "news",
      //       name: "webHomeNews",
      //       component: { render: (e) => e("router-view") },
      //       redirect: { name: "newsIndex" },
      //       meta: {
      //         title: "学院要闻",
      //         icon: "icon-zhuye",
      //         showFoot: false,
      //       },
      //       children: [
      //         {
      //           path: "index",
      //           name: "newsIndex",
      //           component: () =>
      //             import(
      //               /* webpackChunkName: "[request]" */ "@forestage/home/NoticeNewsIndex"
      //             ),
      //           meta: {
      //             title: "学院要闻列表",
      //             icon: "icon-zhuye",
      //             showFoot: false,
      //           },
      //         },
      //         {
      //           path: "detail",
      //           name: "newsDetail",
      //           component: () =>
      //             import(
      //               /* webpackChunkName: "[request]" */ "@forestage/home/NoticeNewsDetail"
      //             ),
      //           meta: {
      //             title: "学院要闻详情",
      //             icon: "icon-zhuye",
      //             showFoot: false,
      //           },
      //         },
      //       ],
      //     },
      //   ],
      // },
      {
        path: "dataAnalysisHome",
        name: "dataAnalysisHome",
        component: () =>
          import(
            "../views/forestage/home/dataAnalysisHome/DataAnalysisHome.vue"
          ),
        meta: {
          title: "首页", //数据分析平台首页
          icon: "icon-zhuye",
          showFoot: false,
          platformName: "数据分析平台",
        },
      },
      {
        path: "wechatLogin",
        name: "wechatLogin",
        component: () =>
          import("../views/forestage/wechatLogin/WechatLogin.vue"),
        meta: {
          title: "",
          icon: "icon-zhuye",
          showFoot: false,
        },
      },
      {
        path: "ScanCode",
        name: "ScanCode",
        component: () => import("../views/forestage/wechatLogin/ScanCode.vue"),
        meta: {
          title: "",
          icon: "icon-zhuye",
          showFoot: false,
          showHeader: false,
        },
      },
      {
        path: "eventService",
        name: "eventService",
        redirect: { name: "eventServiceIndex" },
        component: {
          render: (e) => e("router-view"),
        }, //父路由不需要component的情况
        meta: {
          title: "办事服务大厅",
          icon: "icon-wendang",
        },
        children: [
          {
            path: "index",
            name: "eventServiceIndex",
            component: () =>
              import(
                /* webpackChunkName: "[request]" */ "../views/forestage/eventService/Index.vue"
              ),
            meta: {
              title: "事项列表",
              showFoot: false,
            },
          },
          {
            path: "online",
            name: "eventServiceOnLine",
            component: () =>
              import(
                /* webpackChunkName: "[request]" */ "../views/forestage/eventService/Online.vue"
              ),
            meta: {
              title: "办事指南",
              showFoot: false,
            },
          },
          {
            path: "offline",
            name: "eventServiceOffLine",
            component: () =>
              import(
                /* webpackChunkName: "[request]" */ "../views/forestage/eventService/Offline"
              ),
            meta: {
              title: "线下办理",
              showFoot: false,
            },
          },
          {
            path: "orderline",
            name: "eventServiceOrderLine",
            component: () =>
              import(
                /* webpackChunkName: "[request]" */ "../views/forestage/eventService/Orderline"
              ),
            meta: {
              title: "线下预约",
              showFoot: false,
            },
          },
          {
            path: "viewDetails",
            name: "viewDetails",
            component: () =>
              import(
                /* webpackChunkName: "[request]" */ "../views/forestage/feedback/ViewDetails"
              ),
            meta: {
              title: "查看评价",
              showFoot: false,
            },
          },
          {
            path: "formWrite",
            name: "formWrite",
            component: () =>
              import(
                /* webpackChunkName: "[request]" */ "../views/workflow/view/forestage/formWrite/Index.vue"
              ),
            meta: {
              title: "表单填写",
              showFoot: false,
            },
          },
          {
            path: "AIformWrite",
            name: "AIformWrite",
            component: () =>
              import(
                /* webpackChunkName: "[request]" */ "../views/workflow/view/forestage/AIformWrite/Index.vue"
              ),
            meta: {
              title: "表单填写",
              showFoot: false,
              showSide: false,
              showHeader: false,
              showAI: false,
              showPadding: false,
            },
          },
        ],
      },
      // 数据分析基线不需要以下路由
      /*{
        path: "formHall",
        name: "formHall",
        redirect: "/web/formHall/index",
        component: {
          render: (e) => e("router-view"),
        }, //父路由不需要component的情况
        meta: {
          title: "表单大厅",
          icon: "icon-wendang",
        },
        children: [
          {
            path: "index",
            name: "formHallIndex",
            component: () => import("../views/forestage/formHall/Index"),
            meta: {
              title: "事项列表",
              showFoot: false,
            },
          },
        ],
      },*/
      {
        path: "datasource",
        name: "datasource",
        component: () =>
          import(
            /* webpackChunkName: "[request]" */ "@layouts/forestage/TaskDatasourcelayout"
          ),
        redirect: { name: "dataReporting" },
        meta: {
          title: "数据管理",
          icon: "",
        },
        children: [
          {
            path: "dataReporting",
            name: "dataReporting",
            component: () =>
              import(
                /* webpackChunkName: "[request]" */ "../views/forestage/datasource/DataReporting"
              ),
            meta: {
              title: "数据上报管理",
              icon: "icon-richeng",
              showFoot: false,
            },
          },
          {
            path: "dataTable",
            name: "dataTable",
            component: () =>
              import(
                /* webpackChunkName: "[request]" */ "../views/forestage/datasource/DataTable.vue"
              ),
            meta: {
              title: "数据表管理",
              icon: "icon-richeng",
              showFoot: false,
              showSider: false,
            },
          },
          {
            path: "dataTableEdit",
            name: "dataTableEdit",
            component: () =>
              import(
                /* webpackChunkName: "[request]" */ "../views/forestage/datasource/DataTableEdit.vue"
              ),
            meta: {
              title: "编辑数据表",
              icon: "",
              head: true,
              layout: false,
              showSider: false,
            },
          },
          {
            path: "dataTableOperaRecords",
            name: "dataTableOperaRecords",
            component: () =>
              import(
                /* webpackChunkName: "[request]" */ "../views/forestage/datasource/DataTableOperaRecords.vue"
              ),
            meta: {
              title: "数据表操作记录",
              icon: "",
              head: true,
              layout: false,
              showSider: false,
            },
          },
          // {
          //   path: "dataReportingStatistics",
          //   name: "dataReportingStatistics",
          //   component: () =>
          //     import(
          //       /* webpackChunkName: "[request]" */ "../views/forestage/datasource/DataReportingStatistics"
          //     ),
          //   meta: {
          //     title: "数据上报统计",
          //     icon: "icon-richeng",
          //     showFoot: false,
          //   },
          // },
        ],
      },
      {
        path: "taskCenter",
        name: "taskCenter",
        component: () =>
          import(
            /* webpackChunkName: "[request]" */ "@layouts/forestage/TaskCenterLayout"
          ),
        redirect: { name: "taskWorkBench" },
        meta: {
          title: "审批中心",
          icon: "",
        },
        children: [
          {
            path: "taskWorkBench",
            name: "taskWorkBench",
            component: () =>
              import(
                /* webpackChunkName: "[request]" */ "../views/forestage/taskCenter/TaskWorkBench"
              ),
            meta: {
              title: "工作台",
              icon: "icon-quanbu",
              showFoot: false,
            },
          },
          {
            path: "taskProcessServices",
            name: "taskProcessServices",
            component: () =>
              import(
                /* webpackChunkName: "[request]" */ "../views/workflow/view/forestage/formApproval/Index.vue"
              ),
            meta: {
              title: "表单审批",
              icon: "icon-liucheng",
              showFoot: false,
              app: "workflow",
            },
          },
          {
            path: "formSummary",
            name: "taskFormSummary",
            component: () =>
              import(
                /* webpackChunkName: "[request]" */ //"../views/forestage/taskCenter/FormSummary"
                "../views/workflow/view/forestage/formSummary/Index.vue"
              ),
            meta: {
              title: "表单汇总",
              icon: "icon-wendang",
              showFoot: false,
            },
          },
          {
            path: "formSummaryDetail",
            name: "taskFormSummaryDetail",
            component: () =>
              import(
                /* webpackChunkName: "[request]" */ "../views/forestage/taskCenter/FormSummaryDetail"
              ),
            meta: {
              title: "表单汇总详情",
              icon: "icon-icon_wangye",
              showFoot: false,
              showSider: false,
            },
          },
          {
            path: "reservationServices",
            name: "taskReservationServices",
            component: () =>
              import(
                /* webpackChunkName: "[request]" */ "../views/forestage/taskCenter/TaskReservationService"
              ),
            meta: {
              title: "预约服务",
              icon: "icon-tianbao",
              showFoot: false,
              app: "resourceReservation",
            },
          },
          {
            path: "announceApproval",
            name: "announceApproval",
            component: () => import("../views/information/announceApproval"),
            meta: {
              title: "信息发布",
              icon: "icon-tianbao",
              showFoot: false,
              app: "publisher",
            },
          },
          {
            path: "oneTable",
            name: "taskOneTable",
            component: () =>
              import(
                /* webpackChunkName: "[request]" */ "../views/oneTablePlatform/view/forestage/formApproval/Index.vue"
              ),
            meta: {
              title: "纠错审批",
              icon: "icon-shenqing",
              showFoot: false,
              app: "oneTablePlatform",
            },
          },
          {
            path: "taskErrorCorrectionSummary",
            name: "taskErrorCorrectionSummary",
            component: () =>
              import(
                /* webpackChunkName: "[request]" */ "../views/oneTablePlatform/view/forestage/taskErrorCorrectionSummary/Index.vue"
              ),
            meta: {
              title: "纠错汇总",
              icon: "icon-shenqing",
              showFoot: false,
            },
          },
          {
            path: "taskApproval",
            name: "taskApproval",
            component: () =>
              import(
                /* webpackChunkName: "[request]" */ "../views/taskManagement/views/forestage/taskApproval/TaskApproval.vue"
              ),
            meta: {
              title: "任务审批",
              icon: "icon-shenqing",
              showFoot: false,
              app: "reportFormsCenterTask",
            },
          },
          {
            path: "fillApprove",
            name: "fillApprove",
            component: { render: (e) => e("router-view") },
            redirect: { name: "fillFromApprove" },
            meta: {
              title: "填报审批",
              icon: "icon-shenqing",
              showFoot: false,
            },
            children: [
              {
                path: "fillFromApprove",
                name: "fillFromApprove",
                component: () =>
                  import(
                    /* webpackChunkName: "[request]" */ "../views/dataAcquisition/views/forestage/fillFromApprove/FillFromApprove.vue"
                  ),
                meta: {
                  title: "表单填报",
                  icon: "icon-shenqing",
                  showFoot: false,
                  app: "reportFormsCenterForm",
                },
              },
              {
                path: "dataTableApprove",
                name: "dataTableApprove",
                component: () =>
                  import(
                    /* webpackChunkName: "[request]" */ "../views/forestage/datasource/dataTableApprove/Index.vue"
                  ),
                meta: {
                  title: "数据表",
                  icon: "icon-shenqing",
                  showFoot: false,
                  app: "datatable",
                },
              },
            ],
          },
          {
            path: "taskHistoricalRecord",
            name: "taskHistoricalRecord",
            component: () =>
              import(
                /* webpackChunkName: "[request]" */ "../views/workflow/view/forestage/formApprovalHistory/Index.vue"
              ),
            meta: {
              title: "历史记录",
              icon: "icon-tianbao",
              showFoot: false,
              showSider: false,
            },
          },
          {
            path: "taskFormWrite",
            name: "taskFormWrite",
            component: () =>
              import(
                /* webpackChunkName: "[request]" */ "../views/workflow/view/forestage/formWrite/Index.vue"
              ),
            meta: {
              title: "表单填写",
              head: true,
              layout: false,
              showSider: false,
              showFoot: false,
            },
          },
          {
            path: "dataTablePreview",
            name: "dataTablePreview",
            component: () =>
              import(
                /* webpackChunkName: "[request]" */ "../views/forestage/datasource/dataTablePreview/Index.vue"
              ),
            meta: {
              title: "数据表预览",
              head: true,
              layout: false,
              showSider: false,
            },
          },
        ],
      },
      {
        path: "feedback",
        name: "feedback",
        component: {
          render: (e) => e("router-view"),
        },
        redirect: { name: "feedbackIndex" },
        meta: {
          title: "好差评",
          icon: "icon-haoping",
        },
        children: [
          {
            path: "index",
            name: "feedbackIndex",
            component: () =>
              import(
                /* webpackChunkName: "[request]" */ "../views/forestage/feedback/Index"
              ),
            meta: {
              title: "好差评首页",
              showFoot: false,
            },
          },
        ],
      },
      {
        path: "efficiencySupervise",
        name: "efficiencySupervise",
        component: {
          render: (e) => e("router-view"),
        },
        redirect: { name: "efficiencySuperviseIndex" },
        meta: {
          title: "效能监督",
          icon: "icon-haoping",
        },
        children: [
          {
            path: "index",
            name: "efficiencySuperviseIndex",
            component: () =>
              import(
                /* webpackChunkName: "[request]" */ "../views/forestage/efficiencySupervise/Index"
              ),
            meta: {
              title: "效能监督首页",
              showFoot: false,
            },
          },
        ],
      },
      {
        path: "userCenter",
        name: "userCenter",
        component: { render: (e) => e("router-view") },
        redirect: { name: "myHomepage" },
        meta: {
          title: "个人中心",
          icon: "",
        },
        children: [
          {
            path: "myHomepage",
            name: "myHomepage",
            component: () =>
              import(
                /* webpackChunkName: "[request]" */ "../views/forestage/userCenter/MyHomepage"
              ),
            meta: {
              title: "我的主页",
              icon: "icon-zhuye",
              showFoot: false,
            },
          },
          {
            path: "myCollection",
            name: "myCollection",
            component: () =>
              import(
                /* webpackChunkName: "[request]" */ "../views/forestage/userCenter/MyCollection"
              ),
            meta: {
              title: "我的收藏",
              icon: "icon-collection",
              showFoot: false,
            },
          },
          {
            path: "myFootprint",
            name: "myFootprint",
            component: () =>
              import(
                /* webpackChunkName: "[request]" */ "../views/forestage/userCenter/MyFootprint"
              ),
            meta: {
              title: "我的足迹",
              icon: "icon-zuji",
              showFoot: false,
            },
          },
          {
            path: "mySmartCard",
            name: "mySmartCard",
            component: () =>
              import(
                /* webpackChunkName: "[request]" */ "../views/forestage/userCenter/MySmartCard"
              ),
            meta: {
              title: "我的一卡通",
              icon: "icon-shijian2",
            },
          },
          {
            path: "mySalary",
            name: "mySalary",
            component: () =>
              import(
                /* webpackChunkName: "[request]" */ "../views/forestage/userCenter/MySalary"
              ),
            meta: {
              title: "我的工资",
              icon: "icon-shijian2",
            },
          },
          {
            path: "myBookBorrow",
            name: "myBookBorrow",
            component: () =>
              import(
                /* webpackChunkName: "[request]" */ "../views/forestage/userCenter/MyBookBorrow"
              ),
            meta: {
              title: "我的借阅",
              icon: "icon-shijian2",
            },
          },
          {
            path: "myTimetable",
            name: "myTimetable",
            component: () =>
              import(
                /* webpackChunkName: "[request]" */ "../views/forestage/userCenter/MyTimetable"
              ),
            meta: {
              title: "我的课表",
              icon: "icon-shijian2",
            },
          },
          {
            path: "myScience",
            name: "myScience",
            component: () =>
              import(
                /* webpackChunkName: "[request]" */ "../views/forestage/userCenter/MyScience"
              ),
            meta: {
              title: "我的科研",
              icon: "icon-shijian2",
            },
          },
          {
            path: "accountSettings",
            name: "accountSettings",
            component: () =>
              import(
                /* webpackChunkName: "[request]" */ "../views/forestage/userCenter/AccountSettings"
              ),
            meta: {
              title: "账号设置",
              icon: "icon-tubiao01",
            },
          },
          {
            path: "messageApp",
            name: "messageApp",
            component: () => import("@/views/forestage/userCenter/MessageApp"),
            meta: {
              title: "信息发布",
              icon: "icon-zuji",
              showFoot: false,
              showSide: false,
              hide: true,
            },
          },
          {
            path: "detail",
            name: "MessageDetails",
            component: () =>
              import("@/views/forestage/userCenter/MessageDetails"),
            meta: {
              title: "信息详情",
              icon: "icon-zuji",
              showFoot: false,
              showSide: false,
              hide: true,
            },
          },
        ],
      },
      {
        path: "intelligentAssistant",
        name: "intelligentAssistant",
        component: {
          render: (e) => e("router-view"),
        },
        redirect: { name: "intelligentAssistantIndex" },
        meta: {
          title: "智能助手",
        },
        children: [
          {
            path: "index",
            name: "intelligentAssistantIndex",
            component: () =>
              import(
                /* webpackChunkName: "[request]" */ "../views/forestage/intelligentAssistant/Index"
              ),
            meta: {
              title: "常见问题",
              showFoot: false,
            },
          },
        ],
      },
    ],
  },
  {
    path: "/cms",
    name: "cms",
    component: () =>
      import(
        /* webpackChunkName: "[request]" */ "@layouts/backstage/BackstageLayout"
      ),
    redirect: { name: "cmsHomeIndex" },
    meta: {
      title: "管理后台",
      icon: "icon-zhuye",
    },
    children: [
      {
        path: "home",
        name: "cmsHome",
        component: { render: (e) => e("router-view") },
        redirect: { name: "cmsHomeIndex" },
        meta: {
          title: "首页",
          icon: "",
        },
        children: [
          {
            path: "index",
            name: "cmsHomeIndex",
            component: () =>
              import(/* webpackChunkName: "[request]" */ "@backstage/Home"),
            meta: {
              title: "管理后台首页",
              icon: "icon-zhuye",
              showFoot: false,
            },
          },
        ],
      },
      {
        path: "serviceTool",
        name: "serviceTool",
        component: {
          render: (e) => e("router-view"),
        },
        redirect: { name: "serviceToolIndex" },
        meta: {
          title: "业务工具",
          icon: "",
        },
        children: [
          {
            path: "index",
            name: "serviceToolIndex",
            component: () =>
              import(
                /* webpackChunkName: "[request]" */ "../views/backstage/serviceTool/Index"
              ),
            meta: {
              title: "首页",
            },
          },
          {
            path: "feedback",
            name: "cmsFeedback",
            component: () =>
              import(
                /* webpackChunkName: "[request]" */ "@layouts/backstage/FeedBackLayout"
              ),
            redirect: { name: "feedbackEvaluationManagement" },
            meta: {
              title: "好差评",
            },
            children: [
              {
                path: "feedbackEvaluationManagement",
                name: "feedbackEvaluationManagement",
                component: () =>
                  import(
                    /* webpackChunkName: "[request]" */
                    "../views/backstage/serviceTool/feedback/EvaluationManagement"
                  ),
                meta: {
                  title: "评价管理",
                  icon: "icon-haoping",
                },
              },
              {
                path: "feedbackLabelManagement",
                name: "feedbackLabelManagement",
                component: () =>
                  import(
                    /* webpackChunkName: "[request]" */
                    "../views/backstage/serviceTool/feedback/LabelManagement"
                  ),
                meta: {
                  title: "标签管理",
                  icon: "icon-biaoqian",
                },
              },
              {
                path: "feedbackStatisticalAnalysis",
                name: "feedbackStatisticalAnalysis",
                component: {
                  render: (e) => e("router-view"),
                },
                redirect: { name: "statisticalAnalysisIndex" },
                meta: {
                  title: "统计分析",
                  icon: "icon-shuju2",
                },
                children: [
                  {
                    path: "statisticalAnalysisIndex",
                    name: "statisticalAnalysisIndex",
                    component: () =>
                      import(
                        /* webpackChunkName: "[request]" */
                        "../views/backstage/serviceTool/feedback/statisticalAnalysis/Index"
                      ),
                    meta: {
                      title: "统计分析",
                    },
                  },
                  {
                    path: "statisticalAnalysisItemDetails",
                    name: "statisticalAnalysisItemDetails",
                    component: {
                      render: (e) => e("router-view"),
                    },
                    redirect: { name: "statisticalAnalysisItemDetailsIndex" },
                    meta: {
                      title: "事项详情",
                    },
                    children: [
                      {
                        path: "statisticalAnalysisItemDetailsIndex",
                        name: "statisticalAnalysisItemDetailsIndex",
                        component: () =>
                          import(
                            /* webpackChunkName: "[request]" */
                            "../views/backstage/serviceTool/feedback/statisticalAnalysis/ItemDetails"
                          ),
                        meta: {
                          title: "事项详情",
                        },
                      },
                      {
                        path: "statisticalAnalysisItemDetailsViewEvaluation",
                        name: "statisticalAnalysisItemDetailsViewEvaluation",
                        component: () =>
                          import(
                            /* webpackChunkName: "[request]" */
                            "../views/backstage/serviceTool/feedback/statisticalAnalysis/ViewEvaluation"
                          ),
                        meta: {
                          title: "查看评价",
                        },
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            path: "cmsResourceCenter",
            name: "cmsResourceCenter",
            component: () =>
              import("../views/layouts/backstage/ResourceCenterLayout.vue"),
            redirect: {
              name: "cmsResourceManagement",
            },
            meta: {
              title: "资源中心",
            },
            children: [
              {
                path: "enterpriseNetworkDisk",
                name: "enterpriseNetworkDisk",
                component: {
                  render: (e) => e("router-view"),
                },
                redirect: {
                  name: "generalSituation",
                },
                meta: {
                  title: "企业网盘",
                },
                children: [
                  {
                    path: "generalSituation",
                    name: "generalSituation",
                    component: () =>
                      import(
                        "../views/backstage/serviceTool/resourceCenter/enterpriseNetworkDisk/generalSituation/GeneralSituation.vue"
                      ),
                    meta: {
                      title: "概况",
                    },
                  },
                  {
                    path: "networkDiskSettings",
                    name: "networkDiskSettings",
                    component: () =>
                      import(
                        "../views/backstage/serviceTool/resourceCenter/enterpriseNetworkDisk/networkDiskSettings/NetworkDiskSettings.vue"
                      ),
                    meta: {
                      title: "网盘设置",
                    },
                  },
                  {
                    path: "fileManagement",
                    name: "fileManagement",
                    component: () =>
                      import(
                        "../views/backstage/serviceTool/resourceCenter/enterpriseNetworkDisk/fileManagement/FileManagement.vue"
                      ),
                    meta: {
                      title: "文件管理",
                    },
                  },

                  {
                    path: "fileManagementDetail",
                    name: "fileManagementDetail",
                    component: () =>
                      import(
                        "../views/backstage/serviceTool/resourceCenter/enterpriseNetworkDisk/fileManagement/FileManagementDetail.vue"
                      ),
                    meta: {
                      title: "文件详情",
                    },
                  },
                ],
              },
              {
                path: "cmsResourceManagement",
                name: "cmsResourceManagement",
                component: {
                  render: (e) => e("router-view"),
                },
                redirect: {
                  name: "cmsResourceManagementIndex",
                },
                meta: {
                  title: "资源组管理",
                  permission: ["system:client"],
                },
                children: [
                  {
                    path: "cmsResourceManagementIndex",
                    name: "cmsResourceManagementIndex",
                    component: () =>
                      import(
                        "../views/backstage/serviceTool/resourceCenter/resourceManagement/ResourceManagementIndex.vue"
                      ),
                    meta: {
                      title: "资源管理",
                      permission: ["system:client"],
                    },
                  },
                  {
                    path: "addResoureGroup",
                    name: "addResoureGroup",
                    component: () =>
                      import(
                        "../views/backstage/serviceTool/resourceCenter/resourceManagement/AddResoureGroup.vue"
                      ),
                    meta: {
                      title: "创建资源组",
                    },
                  },
                ],
              },
              {
                path: "propertyManagement",
                name: "propertyManagement",
                component: () =>
                  import(
                    "../views/backstage/serviceTool/resourceCenter/PropertyManagement.vue"
                  ),
                meta: {
                  title: "属性管理",
                  permission: ["system:attributes"],
                },
              },
              {
                path: "labelSet",
                name: "labelSet",
                component: {
                  render: (e) => e("router-view"),
                },
                redirect: {
                  name: "categoryLabels",
                },
                meta: {
                  title: "标签管理",
                  permission: ["tag"],
                },
                children: [
                  {
                    path: "categoryLabels",
                    name: "categoryLabels",
                    component: () =>
                      import(
                        "../views/backstage/serviceTool/resourceCenter/labelSet/CategoryLabels.vue"
                      ),
                    meta: {
                      title: "分类标签",
                      permission: ["tag:category"],
                    },
                  },
                  {
                    path: "personalLabels",
                    name: "personalLabels",
                    component: () =>
                      import(
                        "../views/backstage/serviceTool/resourceCenter/labelSet/PersonalLabels.vue"
                      ),
                    meta: {
                      title: "个性化标签",
                    },
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        path: "publicTool",
        name: "publicTool",
        component: {
          render: (e) => e("router-view"),
        },
        redirect: { name: "publicToolIndex" },
        meta: {
          title: "公共工具",
          icon: "",
        },
        children: [
          {
            path: "index",
            name: "publicToolIndex",
            component: () =>
              import(
                /* webpackChunkName: "[request]" */ "../views/backstage/publicTool/Index"
              ),
            meta: {
              title: "公共工具主页",
            },
          },
          // 数据源服务需要在BI2.4.0版本开发完成之后进行修改文件地址
          {
            path: "datasource",
            name: "cmsDatasource",
            component: () =>
              import(
                /* webpackChunkName: "[request]" */ "../views/bi/layouts/backstage/BiLayout.vue"
              ),
            redirect: { name: "datasourceManagement" },
            meta: {
              title: "数据源服务",
            },
            children: [
              {
                path: "datasourceManagement",
                name: "datasourceManagement",
                component: () =>
                  import(
                    /* webpackChunkName: "[request]" */ "../views/backstage/serviceTool/datasource/datasourceManagement/DatasourceManagement.vue"
                  ),
                meta: {
                  title: "数据源管理",
                  icon: "icon-shuju4",
                },
              },
              {
                path: "datasetGatherManagement",
                name: "datasetGatherManagement",
                component: () =>
                  import(
                    /* webpackChunkName: "[request]" */ "../views/backstage/serviceTool/datasource/datasetGatherManagement/DatasetGatherManagement.vue"
                  ),
                meta: {
                  title: "数据集管理",
                  icon: "icon-jihe",
                },
              },
              {
                path: "datasetManagement",
                name: "datasetManagement",
                component: () =>
                  import(
                    /* webpackChunkName: "[request]" */ "../views/backstage/serviceTool/datasource/datasetManagement/DatasetManagement.vue"
                  ),
                meta: {
                  title: "数据集管理",
                  icon: "",
                  head: false,
                  layout: false,
                },
              },
              {
                path: "datasetDetail",
                name: "datasetDetail",
                component: () =>
                  import(
                    /* webpackChunkName: "[request]" */ "../views/backstage/serviceTool/datasource/datasetDetail/DatasetDetail.vue"
                  ),
                meta: {
                  title: "数据集详情",
                  icon: "",
                  head: false,
                  layout: false,
                },
              },
              {
                path: "dataTableManagement",
                name: "dataTableManagement",
                component: () =>
                  import(
                    /* webpackChunkName: "[request]" */ "../views/backstage/serviceTool/datasource/dataTableManagement/DataTableManagement.vue"
                  ),
                meta: {
                  title: "数据表管理",
                  icon: "icon-richeng",
                },
              },
              {
                path: "dataTableManagementAdd",
                name: "dataTableManagementAdd",
                component: () =>
                  import(
                    /* webpackChunkName: "[request]" */ "../views/backstage/serviceTool/datasource/dataTableManagementAdd/DataTableManagementAdd.vue"
                  ),
                meta: {
                  title: "新增数据表",
                  icon: "",
                  head: false,
                  layout: false,
                },
              },
            ],
          },
          {
            path: "sync",
            name: "cmsSync",
            component: {
              render: (e) => e("router-view"),
            },
            redirect: { name: "cmsSyncIndex" },
            meta: {
              title: "同步管理",
            },
            children: [
              {
                path: "index",
                name: "cmsSyncIndex",
                component: () =>
                  import(
                    /* webpackChunkName: "[request]" */ "../views/backstage/publicTool/syncManage/SyncManage.vue"
                  ),
                meta: {
                  title: "同步管理",
                },
              },
            ],
          },
        ],
      },
      {
        path: "systemSetting",
        name: "cmsSystemSetting",
        component: () =>
          import(
            /* webpackChunkName: "[request]" */ "@layouts/backstage/SystemSettingLayout"
          ),
        redirect: { name: "cmsAccountSettings" },
        meta: {
          title: "系统设置",
          icon: "",
        },
        children: [
          {
            path: "accountSettings",
            name: "cmsAccountSettings",
            component: () =>
              import(
                /* webpackChunkName: "[request]" */ "../views/backstage/systemSetting/AccountSettings"
              ),
            meta: {
              title: "账户设置",
              icon: "",
            },
          },
          {
            path: "platformConfig",
            name: "cmsPlatformConfig",
            component: () =>
              import(
                "../views/backstage/systemSetting/platformConfig/PlatformConfig.vue"
              ),
            meta: {
              title: "平台设置",
              icon: "",
            },
          },
          {
            path: "homepageModulesSetting",
            name: "cmsHomepageModulesSetting",
            component: () =>
              import(
                /* webpackChunkName: "[request]" */
                "../views/backstage/systemSetting/homepageModulesSetting/Index.vue"
              ),
            meta: {
              title: "首页模块设置",
              icon: "",
            },
          },
          {
            path: "organizationManagement",
            name: "cmsOrganizationManagement",
            component: () =>
              import(
                /* webpackChunkName: "[request]" */ "../views/backstage/systemSetting/OrganizationManagement"
              ),
            meta: {
              title: "显示设置",
              icon: "",
            },
          },

          {
            path: "logManagement",
            name: "cmsLogManagement",
            component: () =>
              import(
                /* webpackChunkName: "[request]" */ "../views/backstage/systemSetting/LogManagement"
              ),
            meta: {
              title: "安全审计",
              icon: "",
            },
          },
          {
            path: "dataBackup",
            name: "cmsDataBackup",
            component: () =>
              import(/* webpackChunkName: "[request]" */ "../views/Developing"),
            meta: {
              title: "数据备份",
              icon: "",
            },
          },
          {
            path: "authorizationInformation",
            name: "cmsAuthorizationInformation",
            component: () =>
              import(
                /* webpackChunkName: "[request]" */ "../views/backstage/systemSetting/AuthorizationInformation"
              ),
            meta: {
              title: "授权信息",
              icon: "",
            },
          },
          {
            path: "helpCenter",
            name: "helpCenter",
            component: () =>
              import(
                /* webpackChunkName: "[request]" */
                "../views/backstage/systemSetting/helpCenter/Index.vue"
              ),
            meta: {
              title: "帮助中心",
              icon: "",
            },
          },
        ],
      },
    ],
  },
  {
    path: "/temp",
    name: "temp",
    redirect: { name: "educationBrainScreen" },
    component: () =>
      import(/* webpackChunkName: "[request]" */ "../views/temp/TempLayout"),
    meta: {
      title: "临时文件",
      icon: "icon-zhuye",
    },
    children: [
      {
        path: "largeScreen",
        name: "largeScreen",
        component: () =>
          import(
            /* webpackChunkName: "[request]" */ "../views/temp/LargeScreen"
          ),
        meta: {
          title: "教学概况大屏",
          icon: "icon-zhuye",
        },
      },
      {
        path: "educationBrainScreen",
        name: "educationBrainScreen",
        component: () =>
          import(
            /* webpackChunkName: "[request]" */ "../views/temp/educationBrainScreen"
          ),
        meta: {
          title: "教学概况大屏",
          icon: "icon-zhuye",
        },
      },
    ],
  },
  {
    path: "/mobile",
    name: "mobile",
    redirect: { name: "mobileFlowChart" },
    component: { render: (e) => e("router-view") },
    children: [
      {
        path: "mobileLogin",
        name: "mobileLogin",
        component: () =>
          import(
            /* webpackChunkName: "[request]" */ "@/views/mobile/mobileLogin/Index.vue"
          ),
        meta: {
          title: "统一身份认证",
        },
      },
      {
        path: "mobileFlowChart",
        name: "mobileFlowChart",
        component: () =>
          import(
            /* webpackChunkName: "[request]" */ "@/views/mobile/flowChart/flowChart.vue"
          ),
      },
    ],
  },
];
// 动态添加分包 产品模块的路由（前台、后台路由）
__AUTH__ROUTES.map((v) => {
  if (v.name == "web") {
    web_routers.map((option) => {
      v.children = [...v.children, ...option.router];
    });
  } else if (v.name == "cms") {
    v.children?.map((item) => {
      cms_routers.map((option) => {
        if (item.children) {
          if (option.service == item.path) {
            item.children = [...item.children, ...option.router];
          }
        }
      });
    });
  }
});
//添加权限路由到默认路由中
__DEFAULT__ROUTES.splice(-1, 0, ...__AUTH__ROUTES);
export default __DEFAULT__ROUTES;

/**
 * 路由分类 将引入的路由进行分类
 * @param {Array} routerList
 */
function routeClassification(routerList) {
  routerList.forEach((v) => {
    v.web &&
      web_routers.push({
        router: Array.isArray(v.web) ? v.web : [v.web],
        service: v.service,
      });
    v.cms &&
      cms_routers.push({
        router: Array.isArray(v.cms) ? v.cms : [v.cms],
        service: v.service,
      });
  });
}
